module.exports = __webpack_public_path__ + "img/Giti_icon.353cb8dd.png";